import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=4b7f5c76&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=4b7f5c76&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f5c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7f5c76')) {
      api.createRecord('4b7f5c76', component.options)
    } else {
      api.reload('4b7f5c76', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=4b7f5c76&scoped=true", function () {
      api.rerender('4b7f5c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/dashboard/components/BarChart.vue"
export default component.exports